import './styles/graphic.scss';
import * as d3 from 'd3';
// import { group } from 'd3-array';

export default function (props, container, isMobile) {
  const { initialWidth, initialHeight } = props;

  // Create selector container only for mobile
  const selectorContainer = isMobile ? container.append('div')
    .attr('class', 'region-selector')
    .style('margin-bottom', '10px')
    .style('text-align', 'left') : null;

  const tablesContainer = container.append('div')
    .attr('class', 'tables-container')
    .style('display', 'grid')
    .style('grid-template-columns', isMobile ? '1fr' : 'repeat(2, 1fr)')
    // .style('gap', '20px')
    .style('min-height', '0')
    .style('overflow', 'visible');

  const url = 'https://ix.cnn.io/data/birth-rates/fertility_rates_2016_2024.json';

  fetch(url)
    .then(response => response.json())
    .then((data) => {
      const filtered2024Data = data.state_data.filter(d => d.year === 2024);
      const regionGroups = d3.group(filtered2024Data, d => d.region);
      const sortedRegions = Array.from(regionGroups.keys()).sort();

      console.log(data);

      // Create dropdown only for mobile
      if (isMobile) {
        // Add text before the selector
        selectorContainer.append('span')
          .attr('class', 'selector-label')
          .text('Select a region: ')
          .style('font-weight', 'bold')
          .style('margin-right', '10px');

        // Create select element with event listener
        const select = selectorContainer.append('select')
          .attr('class', 'region-select')
          .on('change', function () { // This is the crucial event listener
            const selectedRegion = this.value;
            if (selectedRegion === 'all') {
              showAllRegions();
            } else {
              showRegion(selectedRegion);
            }
          });

        // Add "All Regions" option
        select.append('option')
          .attr('value', 'all')
          .text('All Regions');

        // Add options for each region
        sortedRegions.forEach((region) => {
          select.append('option')
            .attr('value', region)
            .text(region)
            .property('selected', region === 'Midwest');
        });

        // Show South by default
        showRegion('Midwest');
      }

      // Create tables for all regions
      sortedRegions.forEach((region) => {
        const regionStates = regionGroups.get(region);

        const regionContainer = tablesContainer.append('div')
          .attr('class', 'region-container')
          .attr('data-region', region)
          // Set initial display based on mobile/desktop
          .style('display', isMobile ? 'none' : 'block');

        // Add region header
        regionContainer.append('h3')
          .attr('class', 'region-header')
          .text(region);

        // Group states by division within this region
        const divisionGroups = d3.group(regionStates, d => d.division);
        const sortedDivisions = Array.from(divisionGroups.keys()).sort();

        function createTable(divisionContainer, divisionStates) {
          const table = divisionContainer.append('table');
          const thead = table.append('thead').append('tr');

          // Add sort direction indicator to header
          if (isMobile) {
            thead.append('th')
              .text('State')
              .style('width', '50%');
            thead.append('th')
              .attr('class', 'sortable')
              .html('Rate <span class="sort-arrow">↓</span>')
              .style('width', '50%')
              .style('text-align', 'right')
              .style('cursor', 'pointer')
              .on('click', function () { toggleSort(this, table); });
          } else {
            thead.append('th')
              .text('State')
              .style('width', '60%');
            thead.append('th')
              .attr('class', 'sortable')
              .html('Rate <span class="sort-arrow">↓</span>')
              .style('width', '40%')
              .style('text-align', 'right')
              .style('cursor', 'pointer')
              .on('click', function () { toggleSort(this, table); });
          }

          const tbody = table.append('tbody');
          updateTableRows(tbody, divisionStates, 'desc'); // Initial sort descending

          return table;
        }

        function updateTableRows(tbody, states, sortDirection) {
          // Sort states based on direction
          const sortedStates = states.sort((a, b) => (sortDirection === 'desc'
            ? b.fertility_rate - a.fertility_rate
            : a.fertility_rate - b.fertility_rate));

          // Remove existing rows
          tbody.selectAll('tr').remove();

          // Add new sorted rows
          sortedStates.forEach((d) => {
            const tr = tbody.append('tr');

            tr.append('td')
              .html(`${d.state}`);
            // `<span class="stateface stateface-${d.state_abbr.toLowerCase()}"></span> ${d.state}`)
            tr.append('td')
              .text(d.fertility_rate.toFixed(1))
              .style('text-align', 'right');
          });
        }

        function toggleSort(headerElement, table) {
          const header = d3.select(headerElement);
          const tbody = table.select('tbody');
          const currentDirection = header.attr('data-sort') || 'desc';
          const newDirection = currentDirection === 'desc' ? 'asc' : 'desc';

          // Update sort direction indicator
          header.select('.sort-arrow')
            .html(newDirection === 'desc' ? '↓' : '↑');

          // Store new sort direction
          header.attr('data-sort', newDirection);

          // Get states data from tbody
          const states = [];
          tbody.selectAll('tr').each(function () {
            const row = d3.select(this);
            states.push({
              state: row.select('td').text().trim(),
              state_abbr: row.select('.stateface').attr('class').split('-')[1].toUpperCase(),
              fertility_rate: parseFloat(row.select('td:last-child').text()),
            });
          });

          // Update table with new sort
          updateTableRows(tbody, states, newDirection);
        }

        // Modify your existing division creation code to use the new table creation function
        sortedDivisions.forEach((division) => {
          const divisionStates = divisionGroups.get(division);

          const divisionContainer = regionContainer.append('div')
            .attr('class', 'division-container')
            .style('margin-bottom', '20px');

          divisionContainer.append('h4')
            .attr('class', 'division-header')
            .text(division);

          createTable(divisionContainer, divisionStates);
        });
      });

      // Show first region by default on mobile
      if (isMobile) {
        showRegion(sortedRegions[0]);
      }

      // Functions for mobile region selection
      function showAllRegions() {
        if (isMobile) {
          tablesContainer.selectAll('.region-container')
            .style('display', 'block');

          // Add height adjustment
          const { pymChild } = window;
          if (pymChild) {
            setTimeout(() => {
              pymChild.sendHeight();
            }, 100);
          }
        }
      }

      function showRegion(selectedRegion) {
        if (isMobile) {
          tablesContainer.selectAll('.region-container')
            .style('display', function () {
              const region = d3.select(this).attr('data-region');
              return region === selectedRegion ? 'block' : 'none';
            });

          // Add height adjustment after changing visibility
          const { pymChild } = window;
          if (pymChild) {
            setTimeout(() => {
              pymChild.sendHeight();
            }, 100); // Small delay to ensure content has rendered
          }
        }
      }

      const { pymChild } = window;
      if (pymChild) {
        pymChild.sendHeight();
      }
    });
}
